import { render, staticRenderFns } from "./Ethical.vue?vue&type=template&id=c2c3d96e"
import script from "./Ethical.vue?vue&type=script&lang=js"
export * from "./Ethical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports